import TypeScaleTable from './TypeScaleTable';

export default TypeScaleTable;
